<template>
    <div @click="$emit('click')" class="zhaw-feedback-panel" v-bind:class="{ selected: isSelected }">
        <div class="zhaw-feedback-text">
            <font-awesome-icon v-if="icon === 'smile'" class="zhaw-smile-icon" :icon="['fas', 'smile']"></font-awesome-icon>
            <font-awesome-icon v-if="icon === 'meh'" class="zhaw-meh-icon" :icon="['fas', 'meh']"></font-awesome-icon>
            <font-awesome-icon v-if="icon === 'frown'" class="zhaw-frown-icon" :icon="['fas', 'frown']"></font-awesome-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FeedbackPanel",
        props: {
            icon: String,
            isSelected: Boolean
        },
    }
</script>

<style scoped>
    .zhaw-feedback-panel {
        height: 100px;
        border: 1px solid #00000020;
        border-radius: 5px;
        box-shadow: 1px 1px #00000020;
        cursor: pointer;
    }

    .zhaw-feedback-panel:hover {
        background-color: #f8f9fa;
    }

    .zhaw-feedback-panel:active {
        box-shadow: inset 1px 1px #00000020;
    }

    .zhaw-feedback-panel.selected {
        background-color: #efefef;
        box-shadow: inset 1px 1px #00000020;
    }

    .zhaw-feedback-panel.selected:hover {
        background-color: #efefef;
        box-shadow: inset 1px 1px #00000020;
    }

    .zhaw-feedback-text {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        font-size: 50px;
    }

    .zhaw-smile-icon {
        color: #93c47d;
    }

    .zhaw-meh-icon {
        color: #f6b26b;
    }

    .zhaw-frown-icon {
        color: #e06666;
    }
</style>